/* MIXINS */
import permissionsMixin from '@mixins/permissionsMixin';

export default {
  mixins: [permissionsMixin],
  data() {
    return {
      tabs: [
        {
          name: this.$t('recapitulatif_facturation.offer1'),
          id: 'offer1',
          icon: 'list',
          hidden: !this.isAdmin(),
        },
        {
          name: this.$t('recapitulatif_facturation.offer2'),
          id: 'offer2',
          icon: 'list',
          hidden: !this.isAdmin(),
        },
        {
          name: this.$t('recapitulatif_facturation.offer3'),
          id: 'offer3',
          icon: 'list',
          hidden: !this.isAdmin(),
        },
      ],
    };
  },
  methods: {},
  computed: {
    isPremium() {
      return this.activeTab === 'offer1';
    },
    isConfort() {
      return this.activeTab === 'offer2';
    },
    isEssentiel() {
      return this.activeTab === 'offer3';
    },
  },
};
